import React, { type FC, use, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { FileUploaderContext } from "../../context/FileUploaderContext";
import { FilesExistingItem } from "./FilesExistingItem";
import { useDmsDocumentsMap } from "@domain/context/DmsDataContexts";

export const FilesExisting: FC = () => {
    const { allFilesInfo } = use(FileUploaderContext);
    const documentsMap = useDmsDocumentsMap();

    const hadBeenUploadedFiles = useMemo(
        () => allFilesInfo.filter((el) => el.status === "alreadyUploaded"),
        [allFilesInfo],
    );
    const alreadyExistingValues = useMemo(
        () => ({ count: hadBeenUploadedFiles.length }),
        [hadBeenUploadedFiles.length],
    );

    if (!allFilesInfo.length) {
        return null;
    }

    if (!hadBeenUploadedFiles.length) {
        return null;
    }

    return (
        <div className="mb-5">
            <span className="text-muted">
                <FormattedMessage id="app.dms.upload.alreadyExisting" values={alreadyExistingValues} />
            </span>
            {hadBeenUploadedFiles.map((el, i) => {
                return (
                    <div key={el.hash + i}>
                        <FilesExistingItem document={documentsMap.get(el.hash)} fileName={el.file.name} />
                    </div>
                );
            })}
        </div>
    );
};
